import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { applyCostsSets } from "../_CostsAndOutcomes/applyCostsSets";
import { ApplyCostScaleChange } from "../_CostsAndOutcomes/ApplyCostScaleChange";
import { meetsCostRequirementsSets } from "../_CostsAndOutcomes/meetsCostRequirementsSets";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

/**
 * Generic handler for Auto Collect actions for brick packs
 * Instead of setting autoCollect on individual bricks, this tracks brickpack auto-purchases
 * which will be processed in processAutoCreate by calling BuyBrickPack (with find percentage rolls)
 */
export const AutoCollect_BrickPack_Generic = (
  actionId: string,
  state: State,
) => {
  const newBricks = new Map(state.bricks);
  const newSets = new Map(state.sets);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newBrickPackAutoCollect = new Map(state.brickPackAutoCollect);
  const newActionsTriggeredByType = state.actionsTriggeredByType;

  const action = new Map(state.actions).get(actionId)!;

  // Check if action meets cost requirements (both bricks and sets)
  if (!meetsCostRequirementsSets(action, newBricks, newSets)) return state;

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Costs (both bricks and sets)
  const costsResult = applyCostsSets(
    action,
    newBricks,
    newSets,
    newActionTimestamps,
  );
  if (costsResult === null) return state;

  // Extract brickpack ID from action ID
  // e.g., "auto_collect_brickpack_sloped_bricks_part_one" -> "brickpack_sloped_bricks_part_one"
  // e.g., "auto_collect_brickpack_sloped_bricks_part_one_15" -> "brickpack_sloped_bricks_part_one"
  let brickpackId = actionId.replace("auto_collect_", "");

  // Remove trailing number suffix if present (e.g., "_15", "_3", "_75")
  // This handles upgraded auto-collect actions like "auto_collect_brickpack_sloped_bricks_part_one_15"
  brickpackId = brickpackId.replace(/_\d+$/, "");

  // Get auto-purchase amount from first outcome's baseChangeValue
  // This is how many times per second to purchase the brickpack
  const autoPurchaseAmount =
    action.outcome.length > 0 ? action.outcome[0].baseChangeValue : 0;

  // Update brickPackAutoCollect Map
  // Add the purchase amount to existing value (allows multiple purchases of same action)
  const currentAmount = newBrickPackAutoCollect.get(brickpackId) || 0;
  newBrickPackAutoCollect.set(brickpackId, currentAmount + autoPurchaseAmount);

  // Apply Increase in costScale
  ApplyCostScaleChange(action, updatedActions);

  // Apply Achievement Data
  const newActionsAmt = newActionsTriggeredByType.get(actionId) ?? 0;
  newActionsTriggeredByType.set(actionId, newActionsAmt + 1);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: costsResult.newBricks,
    sets: costsResult.newSets,
    actions: updatedActions,
    actionOrder: newActionOrder,
    brickPackAutoCollect: newBrickPackAutoCollect,
    totalActionsTriggered: state.totalActionsTriggered + 1,
    actionsTriggeredByType: newActionsTriggeredByType,
  };

  return applyAchievementChecks(newState);
};
